// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__c84Ga","image":"Header_image__31Q0v","name":"Header_name__2HDdF","info":"Header_info__1aOK8","infoRow":"Header_infoRow__2kG6M"};